<div
  [class.w-full]="expand()"
  class="flex items-center justify-center gap-2 px-3 transition-all duration-300 ease-in-out cursor-pointer rounded-xl break-keep shrink-0"
  [ngClass]="
    active()
      ? 'border border-primary bg-primary-50 text-primary w-fit text-sm py-2'
      : 'border border-gray-200 bg-white text-gray-400 w-fit text-sm py-2'
  "
>
  @if (icon()) {
    <app-icon
      [name]="icon()"
      [ngClass]="active() ? 'text-primary' : 'text-gray-300'"
      size="md"
    />
  }
  <p class="shrink-0">{{ label() }}</p>

  @if (count()) {
    <p>{{ count() }}</p>
  }
</div>
